import { createSlice } from '@reduxjs/toolkit';
export const user = createSlice({
	name: 'user',
	initialState: {
		role: '',
	},
	reducers: {
		setRole: (state, action) => {
			state.role = action.payload;
		},
	},
});

export const { setRole } = user.actions;
export const getRole = (state) => state.user.role;

export default user.reducer;
